import Onboarding from '../pages/Onboarding';
import PlayNow from '../pages/PlayNow';
import GameInfo from '../pages/GameInfo';
import History from '../pages/History';
import Leaderboard from '../pages/Leaderboard';

const PageManager = {
  onboarding: Onboarding,
  playNow: PlayNow,
  gameInfo: GameInfo,
  history: History,
  leaderboard: Leaderboard,
};

export default PageManager;
